import { API_ENDPOINTS } from "../constants/endpoints";
import api from "../lib/axios";

export const getScreenMasters = () => {
  return api.get(API_ENDPOINTS.ADMIN.SCREEN_MASTER);
};

export const getComponentMasters = () => {
  return api.get(API_ENDPOINTS.ADMIN.COMPONENT_MASTER);
};

export const getInputCategoryMasters = () => {
  return api.get(API_ENDPOINTS.ADMIN.INPUT_CATEGORY_MASTER);
};

export const getKpiMasters = () => {
  return api.get(API_ENDPOINTS.ADMIN.KPI_MASTER);
};

export const createConfiguration = (payload: any) => {
  return api.post(API_ENDPOINTS.ADMIN.CREATE_CONFIGURATION, payload);
};

export const getConfiguration = (payload: any) => {
  const { screenId, componentId, inputCategoryId, kpiId } = payload;

  return api.get(
    `${API_ENDPOINTS.ADMIN.GET_CONFIGURATION_DETAILS}?ScreenId=${screenId}&ComponentId=${componentId}&InputCategoryId=${inputCategoryId}&KpiId=${kpiId}`
  );
};
